/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ServiceTypeEnum {
    WATER = 'Water',
    GAS = 'Gas',
    ELECTRIC = 'Electric',
    SEWER = 'Sewer',
    TRASH = 'Trash',
    TRASH_ADMIN = 'Trash_Admin',
    SPRINKLER = 'Sprinkler',
    INDUSTRIAL = 'Industrial',
    FIRE_LINE = 'Fire_Line',
}